import createValueModule from "@/redux/create-value-module";

import { $ScrollLockModuleName, TScrollLockState } from "./scrollLock.types";

const { constants: _constants, actions } = createValueModule<TScrollLockState>(
    $ScrollLockModuleName,
    {
        lockedDiscriminators: []
    }
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
